import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';

export const AnnualEvolutionServices = () => {
    const { chartData } = useGeneralResultsChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução anual do total de atendimento no município'}
            horizontal={false}
            subtitles={chartData?.annualEvolutionServices?.map((item) => item.description)}
            values={chartData?.annualEvolutionServices?.map((item) => item.total  ||  0)}
        />
    );
};
